/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import { withTheme } from "@material-ui/core/styles";

import styled from "styled-components";

const StyledNoResults = styled((props) => <div {...props} />)`
  display: flex;
  flex: 1 0 auto;
  align-items: center;
  justify-content: center;
  border-bottom: none !important;
  font-size: 32px;
  color: ${(props) => props.theme.palette.grey[400]};
`;

export default withTheme(StyledNoResults);
